import { createLogger } from 'vue-logger-plugin';
// create logger with options
const log = createLogger({
    enabled: true,
    level: 'debug'
});
export default log;
